<template>
	<div class="full-page with-content-box">
		<div class="">
			<a href="/" class="logo">
                <logo></logo>
            </a>
            <div class="container">
            	<div class="content">
            		<h1>{{$t('page.not-supported.headline')}}</h1>
            		<p>{{$t('page.not-supported.text')}}</p>
            	</div>
            	<div class="bottom">
            		<div class="cols">
            			<div class="col">
	            			<div class="icon">
	            				<img src="images/SVG/Browsers/chrome.svg">
	            			</div>
	            			<p>Google Chrome</p>
	            			<a href="https://www.google.com/chrome/" target="_blank" class="button transparent">
	            				{{$t('button.download.label')}}
	            			</a>
	            		</div>
	            		<div class="col">
	            			<div class="icon">
	            				<img src="images/SVG/Browsers/firefox.svg">
	            			</div>
	            			<p>Mozilla Firefox</p>
	            			<a href="https://www.mozilla.org/" target="_blank" class="button transparent">
	            				{{$t('button.download.label')}}
	            			</a>
	            		</div>
	            		<div class="col">
	            			<div class="icon">
	            				<img src="images/SVG/Browsers/edge.svg">
	            			</div>
	            			<p>Microsoft Edge</p>
	            			<a href="https://support.microsoft.com/da-dk/help/4027741/windows-get-microsoft-edge" target="_blank" class="button transparent">
	            				{{$t('button.download.label')}}
	            			</a>
	            		</div>
            		</div>
            	</div>
            </div>
            <div class="footer">
				<div class="">
					<span>©{{ new Date().getFullYear() }} Rently</span>
					<span>   |   </span>
					<span><a href="www.rently.dk" target="_blank">www.rently.dk</a></span>
					<span>   |   </span>
					<span><a href="www.rently.dk/om-os" target="_blank">{{$t('rently.what.label')}}</a></span> 
				</div>
				<p>{{$t('rently.questions.label')}} {{$t('rently.phone-no.label')}}</p>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue';
	import Logo from '../components/Logo';
	export default {
		data: () => ({
		}),
		components:{
			Logo
		}
	}
</script>